const URLs = {
  FRONTEND_URL: 'https://woc.sdslabs.co',
  BACKEND_URL: 'https://woc-backend.sdslabs.co',
  FRONTEND_URL_TEST: 'http://localhost:8080',
  BACKEND_URL_TEST: 'http://localhost:8000',
};

export default URLs;
